export const KATEGORI_TABLE_FIELDS = [
  {
    key: 'name',
    label: 'Kategori',
    thStyle: { minWidth: '160px', fontWeight: '600', color: '#333333' },
    tdClass: 'align-middle text-[14px] text-[#333333]',
  },
  {
    key: 'status',
    label: 'Status',
    thStyle: { minWidth: '120px', fontWeight: '600', color: '#333333' },
    tdClass: 'align-middle',
  },
  {
    key: 'total_campaign',
    label: 'Jumlah Campaign',
    thStyle: { minWidth: '160px', fontWeight: '600', color: '#333333' },
    tdClass: 'align-middle text-[14px] text-[#333333]',
  },
  {
    key: 'total_creator',
    label: 'Jumlah Kreator',
    thStyle: { minWidth: '140px', fontWeight: '600', color: '#333333' },
    tdClass: 'align-middle text-[14px] text-[#333333]',
  },
  {
    key: 'action',
    label: 'Aksi',
    thStyle: {
      minWidth: '110px',
      fontWeight: '600',
      color: '#333333',
      textAlign: 'center',
    },
    tdClass: 'align-middle text-center',
  },
]

export const KATEGORI_STATUS = {
  active: {
    label: 'Active',
    style: {
      color: '#34A770',
      background: '#DCF3EB',
    },
  },
  inactive: {
    label: 'Inactive',
    style: {
      color: '#626262',
      background: '#F4F4F4',
    },
  },
  default: {
    label: 'Default',
    style: {
      color: '#FBA63C',
      background: '#FCEBBE',
    },
  },
}
